import { Routes } from '@angular/router';
import { IsLoggedInGuard } from './shared/utils/guards/isLoggedIn/is-logged-in.guard';
import { AuthShellComponent } from './auth/ui/auth-shell/auth-shell.component';
import { OnboardingShellComponent } from './onboarding/ui/onboarding-shell/onboarding-shell.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { DashboardShellComponent } from './shared/ui/dashboard-shell/dashboard-shell.component';
import { ServicesComponent } from './onboarding/pages/services/services.component';
import { SettingsPage } from './pages/settings/settings.page';
import { TransactionsPage } from './pages/transactions/transactions.page';
import { InsightsPage } from './pages/insights/insights.page';
import { ReportsPage } from './pages/reports/reports.page';

export const routes: Routes = [
  {
    path: '',
    component: DashboardShellComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/dashboard/dashboard.routes').then((m) => m.routes),
      },
      {
        path: 'transactions',
        component: TransactionsPage,
      },
      {
        path: 'services',
        children: [
          {
            path: '',
            component: ServicesComponent,
          },
          {
            path: 'airtime-data',
            component: ServicesComponent,
          },
          {
            path: 'bills-utilities',
            component: ServicesComponent,
          },
        ],
      },
      {
        path: 'settings',
        component: SettingsPage,
      },
      {
        path: 'insights',
        component: InsightsPage,
      },
      {
        path: 'reports',
        component: ReportsPage,
      },
    ],
    canActivate: [IsLoggedInGuard],
  },
  {
    path: 'auth',
    component: AuthShellComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./auth/auth.routes').then((m) => m.routes),
      },
    ],
  },
  // {
  //   path: '__/auth',
  //   component: AuthShellComponent,
  //   children: [
  //     {
  //       path: '',
  //       loadChildren: () => import('./auth/auth.routes').then((m) => m.routes),
  //     },
  //   ],
  // },
  {
    path: 'onboarding',
    component: OnboardingShellComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./onboarding/onboarding.routes').then((m) => m.routes),
      },
    ],
    canActivate: [IsLoggedInGuard],
  },

  { path: '**', component: PageNotFoundComponent },
];
